<template>
  <b-row class="home no-gutters border-classh">
    <b-col class="reduce-padding" cols="12">
      <b-row class="border no-gutters">
        <b-col class="reduce-padding" cols="12">
          <div class="header-area">TED Triggers and Flares
          </div>
        </b-col>

        <!--body-->
        <b-col class="reduce-padding" cols="12">
          <div class="body-area">
            <b-row class=" no-gutters">
              <b-col class="reduce-padding div-sm" cols="12">
                <div class="background-main-img">
                  <svg version="1.1" id="Layer_1" class="eye-img" xmlns="http://www.w3.org/2000/svg" height="556px" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 452 556" style="enable-background:new 0 0 452 556;" xml:space="preserve">
                    <g>
                      <g>
                        <g>
                          <g>
                            <g>
                              <g>
                                <defs>
                                  <rect id="SVGID_1_" x="-7.5" y="-24" width="459.5" height="580" />
                                </defs>
                                <clipPath id="SVGID_2_">
                                  <use xlink:href="#SVGID_1_" style="overflow:visible;" />
                                </clipPath>
                                <g transform="matrix(1 0 0 1 0 0)" style="clip-path:url(#SVGID_2_);">

                                  <image style="overflow:visible;" width="1500" height="626" xlink:href="../images/svgs/BC2E44A9.jpg" transform="matrix(1.5974 0 0 1.5974 -218 -266)">
                                  </image>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                      <g>
                        <text transform="matrix(1 0 0 1 99.2012 394.3779)">
                          <tspan x="0" y="0" style="fill:#010101; font-family:' Arial', Helvetica, sans-serif; font-weight:bold; font-size:37px;">• Environment</tspan>
                          <tspan x="0" y="47" style="fill:#010101; font-family:'Arial', Helvetica, sans-serif; font-weight:bold; font-size:37px;">• Genetics</tspan>
                          <tspan x="0" y="94" style="fill:#010101; font-family:'Arial', Helvetica, sans-serif; font-weight:bold; font-size:37px;">• Hormones</tspan>
                        </text>
                      </g>
                    </g>
                  </svg>

                </div>
              </b-col>
              <b-col class="reduce-padding" cols="12" md="6">
                <div class="left-col">
                  <div class="main-txt">
                    Do you have eye symptoms, or have you been diagnosed with Thyroid Eye Disease (TED)?
                  </div>
                  <div class="btn-area">
                    <router-link :to="{path: '/getStarted'}" exact><button @click="tagNav('Yes Button','pre-launch')" class="btn-get-start ">YES</button></router-link>
                    <router-link :to="{path: '/optionsMain'}" exact><button @click="tagNav('No Button','pre-launch')" class="btn-get-start no-margin">NO</button></router-link>
                  </div>
                  <div class="footer">
                    <sup>*</sup> This tool is not meant to provide medical advice and is for general educational purposes only.
                  </div>
                </div>
              </b-col>
              <b-col class="reduce-padding div-lg" cols="6">
                <div class="background-main-img"></div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>


<script>
/* eslint-disable */
import scrollMixin from "../mixins/scrollMixin";
import taggingMixin from "../mixins/taggingMixin";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "home",
  mixins: [scrollMixin, taggingMixin],
  mounted: function () {
    this.scrollToTop();
    var obj={ 
    'hitType': 'pageview', 
    'page': '/', 
    'title': 'pre-launch' , 
    'location': window.location.href
    };
    try {
      console.log("sending Message:", JSON.stringify(obj));
      window.top.postMessage(JSON.stringify(obj), "*");
    } catch(e) {
      console.log("error sending Message");
    }
  },
  components: {},

  data() {
    return {};
  },
  computed: {
    ...mapGetters("userData", ["userData"]),
  },

  methods: {
    ...mapMutations("userData"),
    start: function () {},
  },
};
</script>

<style lang="scss" scoped>
</style>
